import { coreInitiativesTasksByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesTasksByIdPatchAsyncSlice } from './patch';

export const { requestDeleteCoreInitiativesTasksById, resetDeleteCoreInitiativesTasksById } =
	coreInitiativesTasksByIdDeleteAsyncSlice.asyncActionCreators;

export const { requestPatchCoreInitiativesTasksById, resetPatchCoreInitiativesTasksById } =
	coreInitiativesTasksByIdPatchAsyncSlice.asyncActionCreators;
